/* tslint:disable */
/* eslint-disable */
/**
 * Yaway Workshop API
 * Yaway Workshop API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ApiCaseStatus {
    Pending = 'PENDING',
    Canceled = 'CANCELED',
    Completed = 'COMPLETED'
}

export function ApiCaseStatusFromJSON(json: any): ApiCaseStatus {
    return ApiCaseStatusFromJSONTyped(json, false);
}

export function ApiCaseStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiCaseStatus {
    return json as ApiCaseStatus;
}

export function ApiCaseStatusToJSON(value?: ApiCaseStatus | null): any {
    return value as any;
}

